import fetchUserState from "@api/operations/fetch-customer-state";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import Head from "next/head";
import React from "react";

import Container from "@components/Container";
import Hero from "@components/Hero";
import MainLayout from "@components/MainLayout";
import Spacer from "@components/Spacer";
import SupportContainer from "@components/SupportContainer";

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const {
    cookies: { token },
  } = req;

  // token may not exist yet if you have just accessed the site supply a mock customer in this case
  if (!token) {
    return {
      props: {
        customer: { guest: true },
      },
    };
  }

  const { customer } = await fetchUserState(token);

  return { props: { customer } };
};

type SupportPageProps = InferGetServerSidePropsType<typeof getServerSideProps>;

const SupportPage = ({ customer }: SupportPageProps) => (
  <>
    <Head>
      <title>Support | genie</title>
    </Head>
    <Hero />
    <Spacer size="md" />
    <Container>
      <SupportContainer customer={customer} />
    </Container>
  </>
);

SupportPage.Layout = MainLayout;

export default SupportPage;
